module.exports = __webpack_public_path__ + "img/adult_mark.7ab918c7.svg";